<template>
    <div id="app">
        <router-view/>
    <!--<ul>
        <li v-for="item in value" :key="item.id">
        {{item.title}}-{{item.author}}
        </li>
    </ul>-->
    </div>
</template>

<script>
import {app} from './main'
import Vue from 'vue'

export default {
    name: 'App',
    data () {
        return {
        value:""
        }
    },
    methods:{
        //語言
        changeLang(lang){
            app.$i18n.locale=lang
        },
        //Axios
        getValue(){
            const vm =this;
            const api =`${process.env.APIPATH}/posts`;
            //  console.log(process.env.APIPATH,process.env.APIPSD)
            this.$http.get(api).then((response) => {
                console.log(response.data)
                this.value =  response.data;
            })
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || '2BStudentCenter';
            }
        },
    },
    mounted(){
        
    },
    created(){
        // this.getValue();
    }
}
</script>


<style lang="scss">
    @import './assets/scss/all';
</style>




// WEBPACK FOOTER //
// src/App.vue